import { Buffer } from 'buffer'

// The AWS SDK's SigV4 signer (@smithy/core .../util-buffer-from) references a
// bare `Buffer` global. In the Electron renderer — which loads over the
// non-secure mangofiles:// scheme, so crypto.subtle is unavailable and signing
// falls back to the pure-JS sha256 path — that global is undefined and every
// CloudWatch log send throws "ReferenceError: Buffer is not defined". Browsers
// on https:// use crypto.subtle and never hit this path.
if (typeof globalThis.Buffer === 'undefined') {
  globalThis.Buffer = Buffer
}
